import React, { FC } from 'react'

const Curve: FC = () => (
  <svg
    width="1443"
    height="215"
    viewBox="0 0 1443 215"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="1442.5" height="214.5" fill="white" />
    <path
      d="M1442.5 214.5H0V2.563e-05L61.25 0C77.25 -2.56896e-05 485.226 19.1898 716.75 19.1898C952.098 19.1898 1258.35 5.37215 1384.25 0.189813C1421.25 3.23057e-05 1442.5 2.563e-05 1442.5 2.563e-05V214.5Z"
      fill="url(#paint0_linear_2092_52947)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2092_52947"
        x1="716.75"
        y1="10.6898"
        x2="716.75"
        y2="183.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2F3F5" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default Curve
